import sendApiRequest from '../helpers/axios-setup';

export async function getSurveyList(page, limit, queryOptions, sortingOption) {
  try {
    const response = await sendApiRequest.get('/survey', {
      params: {
        page,
        limit,
        ...queryOptions,
        sorting_option: sortingOption
      }
    });
    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}

export async function createChildFromSurvey(data) {
  try {
    const response = await sendApiRequest.post('/survey/child', data);
    return response.data?.data;
  } catch (e) {
    throw e;
  }
}

export async function sendRemider(data) {
  try {
    const response = await sendApiRequest.post('/survey/reminder', data);
    return response;
  } catch (e) {
    return null;
  }
}

export async function deleteSurvey(survey_id) {
  try {
    const response = await sendApiRequest.delete(`/survey/${survey_id}`);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function createPaymentLink(data) {
  try {
    const response = await sendApiRequest.post('/survey/payment-link', data);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

export async function createCashPayment(data) {
  try {
    const response = await sendApiRequest.post('/survey/cash', data);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

export async function createChequePayment(data) {
  try {
    const response = await sendApiRequest.post('/survey/cheque', data);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

export async function refreshPaymentStatus(data) {
  try {
    const response = await sendApiRequest.post('/survey/payment-status', data);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

export async function restoreSurvey(survey_id) {
  try {
    const response = await sendApiRequest.patch(`/survey/${survey_id}/restore`);
    return response.data?.data;
  } catch (e) {
    return null;
  }
};